import { Card, Col, Row } from 'antd'
import { useEffect } from 'react'

import {
  useDataManagementActions,
  useDataManagementState,
} from '@Store/slices/dataManagementSlice'
import scrollToId from '@Utils/helpers/scroll-to-id'

import RecentImports from './file-import/RecentImports'
import SelectionCard from './SelectionCard'
import { type ProductSource } from '../types/product'
import {
  getManualProductSourceSection,
  getManualProductSources,
} from '../utils/product'

function ProductSourceManual(): JSX.Element {
  const { selectedProductSource } = useDataManagementState()
  const { setSelectedProductSource } = useDataManagementActions()

  const handleClickSource = (source: ProductSource) => {
    setSelectedProductSource(source)
  }

  useEffect(() => {
    scrollToId('selected_product_management')
  }, [selectedProductSource])

  return (
    <>
      <Card
        title={
          <>
            <h1 className="pb-2 text-xl text-gray-900 font-medium flex flex-row items-center">
              Manual Management
            </h1>
            <p className="pr-2 font-normal text-base text-gray-500 mb-4">
              Add products in bulk, update existing ones, or add them one by
              one.
            </p>
          </>
        }
        className="pt-4"
      >
        <Row justify="center" gutter={[24, 24]}>
          {getManualProductSources().map((source: ProductSource) => (
            <Col xs={24} md={8} key={source.id}>
              <SelectionCard
                isActive={selectedProductSource?.id === source.id}
                showCheckbox={false}
                titleElement={
                  <>
                    <h2 className="text-primary-800 text-base font-semibold leading-8 mb-2 flex flex-row items-center">
                      <span className="mr-3">{source.icon}</span>
                      <span className="flex flex-wrap items-baseline">
                        {source.title}
                      </span>
                    </h2>
                  </>
                }
                descriptionElement={
                  <div className="flex flex-col flex-1 pt-2 pb-2">
                    <p className="font-normal text-base text-start text-gray-500">
                      {source.description}
                    </p>
                  </div>
                }
                className="hover:border-primary-600 transition-all [&>div>.link-icon]:hover:translate-x-1"
                onClick={() => handleClickSource(source)}
                linkButtonLabel={source.button}
                onLinkButtonClick={source.onButtonClick}
              />
            </Col>
          ))}
        </Row>
      </Card>
      {selectedProductSource && (
        <div id="selected_product_management" className="pt-8">
          {getManualProductSourceSection(String(selectedProductSource.id))}
        </div>
      )}
      <RecentImports type={['apt', 'upt']} />
    </>
  )
}

export default ProductSourceManual
